/* global Vue, EVENTS, DESTINATIONS */

import Card from './components/Card'
import LoadMore from './components/LoadMore'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'

const i18n = CreateI18n(messagesSpecific)
const EventsApp = Vue.createApp({
  name: 'EventsApp',
  components: { Card, LoadMore },
  template: '#events-app-template',

  setup () {
    const months = Vue.ref([])
    const month = Vue.ref('all')
    const destination = Vue.ref('all')
    const numberOfCards2show = Vue.ref(6)
    const addNoCards = 6
    const localEvents = Vue.ref([])
    const messages = i18n.global.messages.value

    function getMonthName (month) {
      const formatter = new Intl.DateTimeFormat(document.documentElement.lang, { month: 'long' })
      return formatter.format(new Date().setMonth(month))
    }

    const filteredSortedEvents = Vue.computed(() => localEvents.value
      .filter(event => {
        const hasDestination = destination.value === 'all' || event.destination === destination.value
        const isInMonth = month.value === 'all' || event.months?.includes(month.value)
        return hasDestination && isInMonth
      })
      .sort((e1, e2) => {
        const d1 = e1.startdate
        const d2 = e2.startdate
        if (d1.getTime() > d2.getTime()) return 1
        if (d1.getTime() < d2.getTime()) return -1
        return 0
      }))

    const monthDifference = (d1, d2) => {
      let diffMonths = (d2.getFullYear() - d1.getFullYear()) * 12
      diffMonths -= d1.getMonth()
      diffMonths += d2.getMonth()
      return diffMonths <= 0 ? 0 : diffMonths
    }

    const listOfMonthsBetweenDates = (startDate, endDate) => {
      const monthList = []
      for (let i = 0; i <= monthDifference(startDate, endDate); i += 1) {
        const newDate = new Date(startDate)
        const newMonth = newDate.setMonth(newDate.getMonth() + i)
        if (!monthList.includes((new Date(newMonth)).getMonth())) {
          monthList.push((new Date(newMonth)).getMonth())
        }
      }
      return monthList
    }

    Vue.onMounted(async () => {
      EVENTS.forEach((event) => {
        event.startdate = new Date(event.startdate)
        event.expirydate = new Date(event.expirydate)
        event.months = listOfMonthsBetweenDates(event.startdate, event.expirydate)
        months.value = [...new Set([...months.value, ...event.months])]
        localEvents.value.push(event)
      })
      months.value.sort((a, b) => (a - b))
    })

    return {
      months,
      month,
      destination,
      DESTINATIONS,
      filteredSortedEvents,
      numberOfCards2show,
      getMonthName,
      addNoCards,
      messages,
    }
  },
})

const appElement = document.getElementById('events-app')

if (appElement) {
  EventsApp.use(i18n)
  EventsApp.mount(appElement)
}
